/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseDevise } from '../../models/api-response-devise';
import { Devise } from '../../models/devise';

export interface CreateDevise$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: Devise
}

export function createDevise(http: HttpClient, rootUrl: string, params: CreateDevise$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseDevise>> {
  const rb = new RequestBuilder(rootUrl, createDevise.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseDevise>;
    })
  );
}

createDevise.PATH = '/v1/api/ui/devise';
